<template>
    <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
    </div>
</template>

<script>
  export default {
    data() {
      return {}
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Spinner/BounceSpinner.vue